import { FC } from 'react';
import { Route, Switch, useRouteMatch, useHistory } from 'react-router-dom';
import { Typography, Grid, Box } from '@mui/material';
import { common } from '@mui/material/colors';
import { ResourceEditContainer, SimpleForm } from '@prismamedia/one-crud-react';
import { paths, replaceParams } from 'routing';
import { CircularLoader } from 'components/CircularLoader';
import { AppBar } from './AppBar';
import { RoutingTabs } from 'components/RoutingTabs';
import { UPSERT_NEWSLETTER_MUTATION } from 'apollo/mutations/upsertNewsletter.newsletter.graphql';
import { NewsletterConfig } from 'pages/configs/newsletter.config';
import { GET_NEWSLETTER_QUERY } from 'apollo/queries/getNewsletter.newsletter.graphql';
import { Generalities } from './Generalities';
import { afterFetch } from './utils';

export const NewsletterEditPage: FC = () => {
  const history = useHistory();
  const match = useRouteMatch<{
    id: string;
  }>();
  const isCreate = match.path === paths.NEWSLETTER_NEW;

  return (
    <Box
      mt={8}
      sx={{
        backgroundColor: common.white,
      }}
    >
      <RoutingTabs
        tabs={[
          {
            label: 'CONFIGURATION GÉNÉRALE',
            location: {
              pathname: `${match.url}/generalities`,
            },
          },
        ]}
      />
      <ResourceEditContainer
        mutationProps={{
          mutation: UPSERT_NEWSLETTER_MUTATION,
          onCompleted: (data) => {
            if (
              !isCreate ||
              !data.upsertNewsletter ||
              !data.upsertNewsletter.id
            ) {
              return;
            }
            history.push(
              replaceParams(paths.NEWSLETTER_EDIT, {
                id: data.upsertNewsletter.id,
              }),
            );
          },
        }}
        resourceConfig={NewsletterConfig}
        query={GET_NEWSLETTER_QUERY}
        isCreate={isCreate}
        variables={{
          where: {
            id: match.params.id,
          },
        }}
        messages={{
          loading: <CircularLoader fullScreen />,
          error: <Typography>Une erreur est survenue.</Typography>,
          nocontent: <Typography>Aucune données.</Typography>,
        }}
        afterFetch={afterFetch}
        fetchPolicy="network-only"
      >
        <SimpleForm
          style={{
            boxShadow: 'none',
            padding: 0,
            background: 'none',
          }}
        >
          <AppBar isCreate={isCreate} />
          <Grid
            container
            spacing={2}
            sx={{
              margin: 0,
              width: '100%',
            }}
          >
            <Switch>
              <Route
                path={`${match.url}/generalities`}
                render={() => <Generalities />}
              />
            </Switch>
          </Grid>
        </SimpleForm>
      </ResourceEditContainer>
    </Box>
  );
};
